export enum TimeUnitsEnum {
    millisecond = "MILLISECOND",
    second = "SECOND",
    min = "MIN",
    hour = "HOUR"
}
